import { getSchemaForPage } from './schemas'

const getUrlValue = (url) => {
  if (!url) return ''
  return typeof url === 'string' ? url : (url.Href || '')
}

export const getAbsoluteUrl = (url, origin) => {
  if (!url) return ''

  try {
    return origin ? new URL(url, origin).href : new URL(url).href
  } catch {
    return ''
  }
}

export const getPageMeta = (appContext, pathname, origin) => {
  const data = appContext?.data
  const rawUrl = getUrlValue(data?.Url) || pathname

  let robots = data?.MetaRobots || 'index, follow'
  if (process.env.NODE_ENV !== 'production') {
    robots = 'noindex, nofollow'
  }

  const schema = getSchemaForPage(appContext)

  return {
    title: data?.MetaTitle || data?.Name || 'Wellby',
    description: data?.MetaDescription || '',
    keywords: data?.MetaKeywords || '',
    robots,
    canonicalUrl: getAbsoluteUrl(rawUrl, origin),
    schemaList: Array.isArray(schema) ? schema : (schema ? [schema] : [])
  }
}
